var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c("w-card-title", [
        _vm._v(" " + _vm._s(_vm.$ct("logo-extra-settings")) + " "),
      ]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("hide-on-pdf-on-print") },
                    model: {
                      value: _vm.HideOnPdfOnPrint,
                      callback: function ($$v) {
                        _vm.HideOnPdfOnPrint = $$v
                      },
                      expression: "HideOnPdfOnPrint",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("hide-on-pdf-on-email-send") },
                    model: {
                      value: _vm.HideOnPdfOnEmailSend,
                      callback: function ($$v) {
                        _vm.HideOnPdfOnEmailSend = $$v
                      },
                      expression: "HideOnPdfOnEmailSend",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { label: _vm.$ct("hide-on-pdf-on-download") },
                    model: {
                      value: _vm.HideOnPdfOnDownload,
                      callback: function ($$v) {
                        _vm.HideOnPdfOnDownload = $$v
                      },
                      expression: "HideOnPdfOnDownload",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }